import React from 'react'
import { useTranslation } from 'react-i18next'

import './features6.css'

const Features6 = (props) => {
  const { t } = useTranslation()

  return (
    <div className="features6-thq-layout216-elm thq-section-padding">
      <div className="features6-thq-max-width-elm thq-section-max-width thq-flex-row">
        <div className="features6-container thq-flex-column"></div>
        <div className="thq-flex-column features6-thq-content-elm">
          <div className="features6-thq-section-title-elm thq-flex-column">
            <h2 className="thq-heading-2">{t('webview.title')}</h2>
            <p className="thq-body-large">{t('webview.description')}</p>
          </div>
          <div className="features6-thq-list-elm thq-flex-row">
            <div className="features6-thq-list-item-elm1 thq-flex-column">
              <h3 className="thq-heading-3">{t('webview.feature1Title')}</h3>
              <span className="thq-body-small">{t('webview.feature1Desc')}</span>
            </div>
            <div className="features6-thq-list-item-elm2 thq-flex-column">
              <h3 className="thq-heading-3">{t('webview.feature2Title')}</h3>
              <span className="thq-body-small">{t('webview.feature2Desc')}</span>
            </div>
          </div>
          <div className="features6-thq-actions-elm thq-flex-row">
            <button className="thq-button-filled features6-thq-button-elm">
              <a
                href="https://point.place"
                target="_blank"
                rel="noreferrer noopener"
                className="features6-thq-action1-elm thq-body-small"
              >
                {t('webview.action')}
              </a>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Features6
